import { useSnackbarStore } from '@components/shared/Snackbar/store';
import { PackagesStep } from '@features/FindSpecialist';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { motion } from 'framer-motion';
import { FC, useEffect, useState } from 'react';
import { useMonitoringStore } from 'services/monitoring';

export const MonitoringV2Packages: FC = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { setStepsDraft, setInitialStepData } = useMonitoringStore();
	const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
	const [submitIsLoading, setSubmitIsLoading] = useState(false);

	// Use the navigation hijack approach
	useEffect(() => {
		// Instead of modifying the submitInitialStep function directly,
		// we'll listen for navigation events and redirect as needed
		const originalPushState = window.history.pushState;
		const originalReplaceState = window.history.replaceState;

		// Monkey patch history.pushState
		window.history.pushState = function (state, title, url) {
			// Only intercept if we're already in the monitoring-v2 flow
			if (
				url &&
				typeof url === 'string' &&
				window.location.pathname.includes('monitoring-v2') &&
				url.includes('/monitoring/terms') &&
				!url.includes('monitoring-v2/terms')
			) {
				url = url.replace('/monitoring/terms', '/monitoring-v2/terms');
			}
			return originalPushState.call(this, state, title, url);
		};

		// Monkey patch history.replaceState
		window.history.replaceState = function (state, title, url) {
			// Only intercept if we're already in the monitoring-v2 flow
			if (
				url &&
				typeof url === 'string' &&
				window.location.pathname.includes('monitoring-v2') &&
				url.includes('/monitoring/terms') &&
				!url.includes('monitoring-v2/terms')
			) {
				url = url.replace('/monitoring/terms', '/monitoring-v2/terms');
			}
			return originalReplaceState.call(this, state, title, url);
		};

		// Cleanup function to restore original behavior
		return () => {
			window.history.pushState = originalPushState;
			window.history.replaceState = originalReplaceState;
		};
	}, [navigateWithLanguage]);

	// Animation for packages component
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{
				opacity: 1,
				transition: {
					duration: 0.5,
				},
			}}
			className="monitoring-v2-page"
			style={{ overflow: 'visible', height: 'auto' }}
		>
			<PackagesStep />
		</motion.div>
	);
};
